import React, { useState, useContext, useEffect } from 'react';
import { navigate } from 'hookrouter';

import { DataContext } from '../stores/crm-activity-store';
import { GetInitialSettings } from '../components/crm/requests/CommonRequests';
import VirtualScroller from '../components/crm/shared/VirtualScroller';
import { CalculateSettings } from '../components/crm/shared/Functions';
import { Header } from '../components/crm/shared/TableCells';
import { DataContext as SharedDataContext } from '../stores/crm-store';



import ErrorPage from './error';

const CrmActivities = () => {
    const [error] = useState(null);
    const { dispatch: sharedDispatch } = useContext(SharedDataContext);

    const {
        store: { layout, viewSettings }, dispatch: activityDispatch
    } = useContext(DataContext);

    const handleOnClick = (item) => {
        activityDispatch({
            type: 'UPDATE_ACTIVE_ACTIVITY',
            payload: item,
        });
        var anchor = "activity-" + item.id;
        var dealId = item.dealId;
        sharedDispatch({ type: 'SET_ANCHOR_TAG', payload: anchor });
        navigate('/crmDealDetails/' + dealId);
    };

    useEffect(() => {
        let stickyElement = document.querySelector('.sticky-element');

        if (stickyElement !== undefined && stickyElement !== null) {
            let parent = stickyElement.parentElement;

            while (parent) {
                const hasOverflow = getComputedStyle(parent).overflow;
                if (hasOverflow !== 'visible') parent.overflow = 'visible';

                parent = parent.parentElement;
            }
        }
    }, []);

    const content =
        error && error ? (
            <ErrorPage error={error} />
        ) : (
            <section className='w-100 crm-container'>
                <div className='d-flex'>
                    <div className='position-relative justify-content-left align-items-left'>
                        <div className='d-flex flex-column w-100'>
                            <Header layout={layout} dataContext={DataContext} />
                            {viewSettings !== null ? <VirtualScroller dataContext={DataContext} onCellClick={handleOnClick} /> : null}
                        </div>
                    </div>
                </div>
            </section>
        );
    return content;
};

export default CrmActivities;
